<template>
	<div>
		<div class="sk-widget-alt offline-widget">
			<div class="offline-image">
				<img src="/images/2k-out-of-stock.png" alt="We're Closed" />
			</div>
			<h2 class="offline-title">{{ businessName }} is Closed.</h2>
			<h3 class="offline-subtitle" v-if="showPreOrder">
				Pre Order for a delicious meal when they open.
			</h3>
		</div>
		<slot v-if="showPreOrder">
			<button
				v-html="preOrderButton"
				class="button button-primary offline-preorder-button"
				@click="startPreorder"
			>
				Pre Order for Later
			</button>
		</slot>
	</div>
</template>

<style scoped>
.offline-widget {
	max-width: 500px;
	margin: 75px auto 0 auto;
}

.offline-image {
	background: var(--gR-base-80);
	justify-content: center;
	height: 180px;
}

.offline-title,
.offline-subtitle {
	text-align: left;
	margin-left: 15px;
}

.offline-title {
	font-size: 14px;
	margin-bottom: 7px;
	margin-top: 20px;
	color: var(--gR-base-80);
}

.offline-subtitle {
	width: 100%;
	font-size: 12px;
	margin-bottom: 20px;
	color: var(--sk-grey2);
}

.offline-preorder-button {
	margin: 0 auto;
	font-weight: 400;
	margin-top: 45px;
}

.button {
	max-width: 186px;
}
</style>

<script>
import { eventBus } from "@/eventBus"
import { EventBusEvents } from "@/enums/EventBusEvents"
import { BusinessType } from "@reef-os/utils/enums/businessType"

export default {
	name: "OfflineWidget",
	computed: {
		businessName() {
			return this.$store.state.business && this.$store.state.business.name
				? this.$store.state.business.name
				: ""
		},
		showPreOrder() {
			return this.$store.state.business.type !== BusinessType.AIRPORT
		},
		preOrderButton() {
			return "Pre Order for Later"
		}
	},
	methods: {
		startPreorder() {
			eventBus.emit(EventBusEvents.OPEN_MENU_TIME_MODAL, {
				date: this.$store.state.deliveryDate
			})
		}
	}
}
</script>